import { atom } from "recoil"

export const ShowProgress = atom({
  key: "showProgress",
  default: false,
})
